import React, { useEffect, useState } from "react";
import { Row, Col, Form, InputGroup } from "react-bootstrap";
import { FeedNumberValidationRules, parseNumericInput } from "../../utils/InputValidator";
import { Tooltip } from "react-tooltip";

const PortStopFeedLoading = ({ label, stopData, onChange, uniqueID }) => {
    const [loadingPellets, setLoadingPellets] = useState(0);
    const [loadingGrain, setLoadingGrain] = useState(0);
    const [loadingRoughage, setLoadingRoughage] = useState(0);

    useEffect(() => {
        setLoadingPellets(stopData.pellets);
        setLoadingGrain(stopData.grain);
        setLoadingRoughage(stopData.roughage);
    }, [stopData, stopData.pellets, stopData.grain, stopData.roughage])

    return (
        <Row className="mb-2">
            <Col xs={6} className="cc-feed-plan-row-label">{label}</Col>
            <Col xs={2}>
                <Form.Group>
                    <InputGroup>
                        <Form.Control
                            id={`txtFeed_Pellets_${uniqueID}`}
                            onChange={(e) => {
                                e.preventDefault();
                                parseNumericInput(e, new FeedNumberValidationRules());
                                setLoadingPellets(e.target.value)
                                onChange("pellets", e.target.value);
                            }}
                            onFocus={() => {
                                if (loadingPellets === 0) {
                                    setLoadingPellets("");
                                }
                            }}
                            onBlur={() => {
                                if (loadingPellets === "") {
                                    setLoadingPellets(0);
                                }
                            }}
                            value={loadingPellets}
                            className="inputGroupWithAppend errorLeft"
                        />
                        <InputGroup.Text className={`inputGroupAppend ${!stopData.pelletsValid ? "invalidAppend" : ""}`}>t</InputGroup.Text>
                        {
                            !stopData?.pelletsValid ? (
                                <div className="validation-error-tooltip">
                                    <Tooltip
                                        anchorSelect={`#txtFeed_Pellets_${uniqueID}`}
                                        place="top"
                                        variant="error"
                                        content="A valid pellets amount is required."
                                    />
                                </div>
                            ) : null
                        }
                    </InputGroup>
                </Form.Group>
            </Col>
            <Col xs={2}>
                <Form.Group>
                    <InputGroup>
                        <Form.Control
                            id={`txtFeed_Grain_${uniqueID}`}
                            onChange={(e) => {
                                e.preventDefault();
                                parseNumericInput(e, new FeedNumberValidationRules());
                                setLoadingGrain(e.target.value);
                                onChange("grain", e.target.value);
                            }}
                            onFocus={() => {
                                if (loadingGrain === 0) {
                                    setLoadingGrain("");
                                }
                            }}
                            onBlur={() => {
                                if (loadingGrain === "") {
                                    setLoadingGrain(0);
                                }
                            }}
                            value={loadingGrain}
                            className="inputGroupWithAppend errorLeft"
                        />
                        <InputGroup.Text className={`inputGroupAppend ${!stopData.grainValid ? "invalidAppend" : ""}`}>t</InputGroup.Text>
                        {
                            !stopData?.grainValid ? (
                                <div className="validation-error-tooltip">
                                    <Tooltip
                                        anchorSelect={`#txtFeed_Grain_${uniqueID}`}
                                        place="top"
                                        variant="error"
                                        content="A valid grain amount is required."
                                    />
                                </div>
                            ) : null
                        }
                    </InputGroup>
                </Form.Group></Col>
            <Col xs={2}>
                <Form.Group>
                    <InputGroup>
                        <Form.Control
                            id={`txtFeedRoughage_${uniqueID}`}
                            onChange={(e) => {
                                e.preventDefault();
                                parseNumericInput(e, new FeedNumberValidationRules());
                                setLoadingRoughage(e.target.value);
                                onChange("roughage", e.target.value);
                            }}
                            onFocus={() => {
                                if (loadingRoughage === 0) {
                                    setLoadingRoughage("");
                                }
                            }}
                            onBlur={() => {
                                if (loadingRoughage === "") {
                                    setLoadingRoughage(0);
                                }
                            }}
                            value={loadingRoughage}
                            className="inputGroupWithAppend errorLeft"
                        />
                        <InputGroup.Text className={`inputGroupAppend ${!stopData.roughageValid ? "invalidAppend" : ""}`}>t</InputGroup.Text>
                        {
                            !stopData?.pelletsValid ? (
                                <div className="validation-error-tooltip">
                                    <Tooltip
                                        anchorSelect={`#txtFeedRoughage_${uniqueID}`}
                                        place="top"
                                        variant="error"
                                        content="A valid roughage amount is required."
                                    />
                                </div>
                            ) : null
                        }
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
    )
}

export default PortStopFeedLoading;